import React from 'react';
import {Divider, Form, Icon, Popconfirm} from 'antd';
import {Link} from 'react-router-dom';
import {ClientBase} from "./ClientBase";

class ClientsEditApp extends ClientBase {

    customButtons(key, id) {
        const clientDeleteLink =
            <Popconfirm title={'¿Eliminar este cliente?'} onConfirm={() => {
                this.deleteClient(this.state.client)
            }} cancelText={'Cancelar'}>
                <a href="#delete"><Icon type="delete" theme="twoTone"/></a>
            </Popconfirm>;

        const clientManageLink =
            <span>
                <Link to={"/management/" + id}><Icon type="setting" theme="twoTone"/></Link>
                <Divider type="vertical"/>
            </span>;

        return <div><span onClick={(e) => this.showDrawer()} key={"edit" + key}>
                    <a href="#edit">
                        <Icon type="edit" theme="twoTone"/>
                    </a>
            </span>
            <Divider type="vertical"/>
            {clientManageLink}
            {clientDeleteLink}
        </div>
    }
}

const ClientsEdit = Form.create()(ClientsEditApp);
export default ClientsEdit;


// WEBPACK FOOTER //
// ./src/app/views/clients/ClientsEdit.js